import React, { useState, useContext, useEffect } from 'react';
import {
  Plus, Trash2, Crown, Star, Zap, Users, Briefcase, Globe, Check, X, Edit2
} from 'lucide-react';
import axios from 'axios';
import AppContext from '../../../../context/AppContext';
import '../../../../../src/assets/css/screens/admin/dashboard/subscriptions/Subscription.css';
//Constants
const DURATIONS = ['Monthly', 'Quarterly', 'Yearly'];
const AUDIENCES = ['Customers', 'Workers', 'Both'];
const TIERS = ['Basic', 'Pro', 'Elite'];
//Tier icon map 
const TIER_ICON = {
  Basic: <Zap size={18} />,
  Pro: <Star size={18} />,
  Elite: <Crown size={18} />,
};
// Tier gradient map
const TIER_GRADIENT = {
  Basic: 'sub-card--basic',
  Pro: 'sub-card--pro',
  Elite: 'sub-card--elite',
};
//Audience icon
const AudienceIcon = ({ audience }) => {
  if (audience === 'Workers') {
    return (
      <>
        <Briefcase size={13} />&nbsp;Worker</>
    );
  }
  if (audience === 'Both') {
    return (
      <>
        <Globe size={13} />&nbsp;Both
      </>);
  }
  return (
    <>
      <Users size={13} />&nbsp;Customer
    </>);
};
const AdminSubscription = () => {
  const { baseUrl, authToken } = useContext(AppContext);
  const [plans, setPlans] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [planName, setPlanName] = useState('');
  const [price, setPrice] = useState('');
  const [duration, setDuration] = useState('Monthly');
  const [audience, setAudience] = useState('Customers');
  const [tier, setTier] = useState('Basic');
  const [features, setFeatures] = useState('');
  // OPEN ADD MODAL
  const openModal = () => {
    setPlanName('');
    setPrice('');
    setDuration('Monthly');
    setAudience('Customers');
    setTier('Basic');
    setFeatures('');
    setEditingId(null);
    setShowModal(true);
  };
  //CLOSE MODAL
  const closeModal = () => {
    setShowModal(false);
    setEditingId(null);
  };
  // OPEN EDIT MODAL
  const openEditModal = (plan) => {
    setPlanName(plan.planName);
    setPrice(plan.price);
    setDuration(plan.duration);
    setAudience(plan.audience);
    setTier(plan.tier);
    setFeatures(
      Array.isArray(plan.features)
        ? plan.features.join(', ')
        : plan.features
    );
    setEditingId(plan.id);
    setShowModal(true);
  };
  // CREATE PLAN
  const handleAdd = () => {
    if (!planName || !price || !features) {
      alert('Please fill all required fields');
      return;
    }
    setLoading(true);
    const formData = new FormData();
    formData.append('planName', planName);
    formData.append('price', price);
    formData.append('duration', duration);
    formData.append('audience', audience);
    formData.append('tier', tier);
    formData.append('features', features);
    axios.post(`${baseUrl}/create/subscription`, formData,
      {
    headers: {
      Authorization: `Bearer ${authToken}`
    }
  })
      .then(() => {
        viewAllPlans();
        setLoading(false);
        closeModal();
        alert('Plan added successfully!');
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
        alert('Network Error!');
      });
  };
  // VIEW ALL PLANS
  const viewAllPlans = () => {
    axios.get(`${baseUrl}/view/subscription`,
      {
    headers: {
      Authorization: `Bearer ${authToken}`
    }
  }
    )
      .then((response) => {
        console.log(response.data.sub);
        setPlans(response.data.sub);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  
  // UPDATE PLAN
  const handleEdit = () => {
    if (!planName || !price || !features) {
      alert('Please fill all required fields');
      return;
    }
    setLoading(true);
    const formData = new FormData();
    formData.append('id', editingId);
    formData.append('planName', planName);
    formData.append('price', price);
    formData.append('duration', duration);
    formData.append('audience', audience);
    formData.append('tier', tier);
    formData.append('features', features);
    axios.post(`${baseUrl}/update/subscription`, formData,
      {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then(() => {
        viewAllPlans();
        setLoading(false);
        closeModal();
        alert('Plan updated successfully!');
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
        alert('Network Error!');
      });
  };
  // DELETE PLAN
  const handleDelete = (id) => {
    const formData = new FormData();
    formData.append('id', id);
    axios.post(`${baseUrl}/delete/subscription`, formData,
      {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then(() => {
        viewAllPlans();
        alert('Plan deleted successfully!');
      })
      .catch((error) => {
        console.log(error);
      });
  };


  useEffect(() => {
    viewAllPlans();
  }, []);
  

  return (
    <div className="sub-page">
      {/* HEADER */}
      <div className="sub-header">
        <div className="sub-header__left">
          <div>
            <h2 className="sub-title">Subscription Plans</h2>
            <p className="sub-subtitle"> Create and manage premium plans for customers and workers</p>
          </div>
        </div>
        <button className="sub-add-btn"
          onClick={openModal}>
          <Plus size={16} />
          Add New Plan</button>
      </div>
      {/* PLANS GRID */}
      {plans.length > 0 && (
        <div className="sub-section">
          <p className="sub-section__label">Active Plans ({plans.length})</p>
          <div className="sub-grid">
            {plans.map((plan, i) => (
              <div
                key={plan.id}
                className={`sub-card ${TIER_GRADIENT[plan.tier] || 'sub-card--basic'}`}
                style={{
                  animationDelay: `${i * 0.08}s`
                }}>
                {/* ACTION BUTTONS */}
                <div className="sub-card__actions">
                  <button className="sub-card__edit"
                    onClick={() => openEditModal(plan)}>
                    <Edit2 size={14} />
                  </button>
                  <button className="sub-card__del"
                    onClick={() => handleDelete(plan.id)}>
                    <Trash2 size={14} />
                  </button>
                </div>
                {/* ICON */}
                <div className="sub-card__icon">
                  {TIER_ICON[plan.tier] || <Star size={18} />}
                </div>
                {/* NAME */}
                <h3 className="sub-card__name">
                  {plan.planName}
                </h3>
                {/* PRICE */}
                <div className="sub-card__price">
                  <span className="sub-card__price-val">
                    ${plan.price}
                  </span>
                  <span className="sub-card__price-per">
                    / {plan.duration.toLowerCase()}
                  </span>
                </div>
                {/* AUDIENCE */}
                <div className="sub-card__audience">
                  <AudienceIcon audience={plan.audience} />
                </div>
                {/* FEATURES */}
                <ul className="sub-card__features">
                  {plan.features.split(",").map((f, fi) => (
                      <li key={fi}>
                        <Check size={13} className="sub-card__check" />
                        {f}</li>
                    ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      )}
      {/* EMPTY STATE */}
      {plans.length === 0 && (
        <div className="sub-empty">
          <Crown size={40} />
          <p>No plans yet. Add your first subscription plan.</p>
        </div>
      )}
      {/* MODAL */}
      {showModal && (
        <div className="sub-overlay" onClick={closeModal}>
          <div className="sub-modal" onClick={(e) => e.stopPropagation()}>
            <div className="sub-modal__header">
              <div className="sub-modal__header-left">
                {editingId ? (
                  <Edit2 size={16} className="sub-modal__plus" />) : (
                  <Plus size={16} className="sub-modal__plus" />)}
                <h3 className="sub-modal__title">
                  {editingId
                    ? 'Edit Plan'
                    : 'Add New Plan'}
                </h3>
              </div>
              <button className="sub-modal__close" onClick={closeModal}>
                <X size={17} />
              </button>
            </div>
            <div className="sub-modal__body">
              {/* ROW 1 */}
              <div className="sub-modal__row">
                <div className="sub-field">
                  <label className="sub-label">Plan Name
                    <span className="sub-required">*</span>
                  </label>
                  <input
                    className="sub-input"
                    placeholder="e.g. Premium"
                    value={planName}
                    onChange={(e) => setPlanName(e.target.value)} />
                </div>
                <div className="sub-field">
                  <label className="sub-label">
                    Price (USD)
                    <span className="sub-required">*</span>
                  </label>
                  <input
                    className="sub-input"
                    type="number"
                    placeholder="19.99"
                    min="0"
                    step="0.01"
                    value={price}
                    onChange={(e) => setPrice(e.target.value)} />
                </div>
              </div>
              {/* ROW 2 */}
              <div className="sub-modal__row">
                <div className="sub-field">
                  <label className="sub-label">
                    Duration
                  </label>
                  <select
                    className="sub-select"
                    value={duration}
                    onChange={(e) => setDuration(e.target.value)}
                  >
                    {DURATIONS.map((d) => (
                      <option key={d}>
                        {d}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="sub-field">
                  <label className="sub-label">
                    Audience
                  </label>
                  <select
                    className="sub-select"
                    value={audience}
                    onChange={(e) =>
                      setAudience(e.target.value)
                    }>
                    {AUDIENCES.map((a) => (
                      <option key={a}>
                        {a}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              {/* ROW 3 */}
              <div className="sub-field">
                <label className="sub-label">
                  Tier
                </label>
                <select
                  className="sub-select"
                  value={tier}
                  onChange={(e) =>
                    setTier(e.target.value)
                  }>
                  {TIERS.map((t) => (
                    <option key={t}>
                      {t}
                    </option>
                  ))}
                </select>
              </div>
              {/* FEATURES */}
              <div className="sub-field">
                <label className="sub-label">
                  Features
                  <span className="sub-required">*</span>
                  <span className="sub-label-hint">
                    (separated with commas)
                  </span>
                </label>
                <textarea
                  className="sub-textarea"
                  rows={5}
                  placeholder="Unlimited bookings, Priority support, Verified badge"
                  value={features}
                  onChange={(e) =>
                    setFeatures(e.target.value)
                  }
                />
              </div>
            </div>
            <div className="sub-modal__footer">
              <button className="sub-modal__cancel" onClick={closeModal}>Cancel
              </button>
              <button
                className="sub-modal__submit"
                onClick={
                  editingId
                    ? handleEdit
                    : handleAdd
                }
                disabled={loading}>
                {loading ? (
                  editingId
                    ? 'Updating...'
                    : 'Adding...'
                ) : (
                  editingId ? (
                    <><Edit2 size={14} />Update Plan</>
                  ) : (
                    <><Plus size={14} />Add Plan</>
                  ))}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};


export default AdminSubscription;
